<template>
  <el-form
      ref="form"
      :model="form"
      :rules="rules"
      :label-position="labelPosition"
      label-width="120px"
  >
    <el-form-item
        label="机器人名称"
        prop="appName"
    >
      <el-input
          placeholder="请输入"
          v-model="form.appName"
      ></el-input>
    </el-form-item>
    <el-form-item
        label="描述"
        prop="appDesc"
    >
      <el-input
          placeholder="请输入"
          v-model="form.appDesc"
      ></el-input>
    </el-form-item>
    <el-form-item
        label="APP ID"
        prop="appId"
    >
      <el-input
          placeholder="请输入"
          v-model="form.appId"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="APP 密钥"
      prop="appSecret"
    >
      <el-input
          v-model="form.appSecret"
      ></el-input>
    </el-form-item>
    <el-form-item
        label="事件加密密钥"
        prop="eventEncryptKey"
    >
      <el-input
          v-model="form.eventEncryptKey"
      ></el-input>
    </el-form-item>
    <el-form-item
        label="事件验签token"
        prop="eventVerificationToken"
    >
      <el-input
          v-model="form.eventVerificationToken"
      ></el-input>
    </el-form-item>
      <el-form-item
          label="状态"
          prop="status"
      >
          <el-radio
              v-model="form.status"
              :label="1"
          >启用</el-radio>
          <el-radio
              v-model="form.status"
              :label="0"
          >禁用</el-radio>
      </el-form-item>
  </el-form>
</template>

<script>
import formLabalPosition from "@/mixins/formLabalPosition";
let originForm = {
  appName: '',
  appDesc: '',
  appId: '',
  appSecret: '',
  eventEncryptKey: '',
  eventVerificationToken: '',
  status: 1,
}
export default {
  name: "wechatForm",
  components:{
  },
  props: {
    formData:{
      type: Object,
      default(){
        return {
          ...originForm,
        }
      }
    },
  },

  data() {
    return {
      form: {
        ...originForm,
      },
      rules:{
        appName: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        appDesc:[
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        appId:[
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        appSecret:[
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        eventEncryptKey:[
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        eventVerificationToken:[
          { required: true, message: '请输入', trigger: 'blur' },
        ],
      },
    }
  },
  computed: {

  },
  mixins: [formLabalPosition],
  watch:{
    formData:{
      handler(newVal,oldVal){
        if(newVal){
            this.assign();
        }
      },
      deep:true,
    },
  },
  created(){
      this.assign();
  },
  methods:{
      assign(){
          this.form = {
              ...this.formData,
          }
      },
    reset(){
      this.form = {
        ...originForm,
      };
    },
    validate(){
      this.$refs.form.validate((valid) => {
        if(valid){
          this.$emit('submit',this.form);
        }else {
          console.log('no-pass')
        }
      })
    },
  },
}
</script>

<style scoped>

</style>
